export default __webpack_public_path__ + "static/media/benefit_15@2x.0ccd2d91.png";